import React from 'react'
import AnimateImageFour from './AnimateImageFour'
import AnimateTitleFour from './AnimatedTitleFour'

const Sampling = () => {
    return (
        <section className='section-sampling section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-5'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>With the embroidery artwork ready, our artisans begin the process of sampling. Materials are sourced in alignment with the color story and mood board, and small test frames are created to bring the concept to life. Once approved, these samples are carefully translated onto garment panels, setting the tone for production. Every sample is a study in balance — of color, texture, and technique — ensuring that the final piece embodies perfection.</p>
                     </div>
                   </div>
                </div>
                <div className='col-md-7'>
                    <div className='section-img-heading'>
                     <div className='section-title'>
                        <AnimateTitleFour/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageFour/>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default Sampling